<template>
  <div
    class="bg-ontick-graphite-700 grid last:rounded-b-lg"
    :class="numberOfColumns"
  >
    <div class="td">
      <span class="sr-only"> Sem ações disponíveis </span>
    </div>
    <div class="td">
      <div class="flex items-center">
        <span>
          {{ investment.type === "PORTFOLIO" ? "Portfólio" : "Estratégia" }}
        </span>
      </div>
    </div>
    <div class="td w-48 truncate !text-left" :class="nameColumnSize">
      {{ investment.strategy_name }}
    </div>
    <div class="td" v-if="activeColumns.includes('Ativo')">
      <span v-if="investment.strategy_symbol === 'PORTFOLIO'">
        {{ investment.strategy_symbol }}
      </span>
      <span
        v-else
        class="bg-ontick-teal-600 text-ontick-teal-50 rounded px-2 py-1"
      >
        {{ investment.strategy_symbol }}
      </span>
    </div>
    <div class="td" v-if="activeColumns.includes('Volume')">
      {{ investment.position_volume ? investment.position_volume : "-" }}
    </div>
    <div
      class="td font-bold uppercase"
      v-if="activeColumns.includes('Posição')"
    >
      {{ investment.position_status }}
    </div>
    <div class="td" v-if="activeColumns.includes('Acumulado')">
      {{ investment.closed_pnl | currency }}
    </div>
    <div class="td" v-if="activeColumns.includes('Resultado')">
      {{ investment.open_pnl }}
    </div>
    <div
      class="td divide-ontick-carbon-900 flex items-center justify-center divide-x dark:divide-gray-300"
      v-if="activeColumns.includes('Status')"
    >
      <span v-if="investment.type === 'PORTFOLIO'"> - </span>
      <template v-else>
        <span v-if="!status.length"> - </span>
        <span
          v-else-if="status.length === 1"
          class="font-bold uppercase"
          :class="status[0].color"
          :content="status[0].tooltip"
          v-tippy="{ arrow: true, theme: 'green' }"
        >
          {{ status[0].name }}
        </span>
        <template v-else-if="status.length > 1">
          <span
            v-for="item in status"
            :key="item.name"
            class="px-2 font-bold uppercase"
            :class="item.color"
            :content="item.tooltip"
            v-tippy="{ arrow: true, theme: 'green' }"
          >
            {{ item.name.charAt(0) }}
          </span>
        </template>
      </template>
    </div>
    <div
      class="td text-ontick-red-600"
      v-if="activeColumns.includes('Perda máx.')"
    >
      {{ investment.max_daily_loss ? investment.max_daily_loss : "-" }}
    </div>
    <div
      class="td text-ontick-green-600"
      v-if="activeColumns.includes('Ganho máx.')"
    >
      {{ investment.max_daily_gain ? investment.max_daily_gain : "-" }}
    </div>
  </div>
</template>

<script>
import * as icons from "@/app/assets/icons/investments";
import OntickToggleComponent from "../../../ontick-toggle/ontick-toggle.component.vue";
import statusIndicatorComponent from "../../card-investment/status-indicator.component.vue";
import EventBus from "@/app/shared/utils/event_bus.js";

export default {
  props: {
    investment: {
      type: Object,
      required: true,
    },
  },
  components: {
    OntickToggleComponent,
    statusIndicatorComponent,
  },
  data() {
    return {
      toggle_disabled: true,

      typed_volume: this.investment.curr_volume,

      optionDefault: {
        icon: icons.details,
        label: null,
      },
      optionsSelect: [
        { icon: icons.editParams, label: "Parâmetros" },
        { icon: icons.performance, label: "Histórico" },
        {
          icon: icons.removeInvestment,
          label:
            this.investment.status != "HIDDEN" ? "Arquivar" : "Desarquivar",
        },
      ],
      activeColumns: localStorage.getItem("listModeColumns")
        ? localStorage.getItem("listModeColumns").split(",")
        : null,
    };
  },
  computed: {
    nameColumnSize() {
      return this.activeColumns.length > 6 ? "col-span-1" : "col-span-2";
    },
    numberOfColumns() {
      return this.activeColumns
        ? `grid-cols-${this.activeColumns.length + 4}`
        : "grid-cols-10";
    },
    status() {
      let statuses = [];
      if (this.investment.mask_gain) {
        statuses.push({
          name: "Gain",
          color: "text-ontick-green-700 dark:text-ontick-green-600",
          tooltip: "Limite de ganho atingido",
        });
      }
      if (this.investment.mask_loss) {
        statuses.push({
          name: "Loss",
          color: "text-ontick-red-700 dark:text-ontick-red-600",
          tooltip: "Limite de perda atingido",
        });
      }
      if (this.investment.mask_time) {
        statuses.push({
          name: "Tempo",
          color: "text-ontick-teal-700 dark:text-ontick-teal-600",
          tooltip: "Limite de tempo atingido",
        });
      }
      if (this.investment.mask_limit) {
        statuses.push({
          name: "Limite",
          color: "text-ontick-pink-700 dark:text-ontick-pink-600",
          tooltip: "Limite operacional atingido",
        });
      }
      return statuses;
    },
  },
  created() {
    EventBus.$on("UPDATE_LIST_COLUMNS", (value) => {
      this.activeColumns = value.split(",");
      console.log("log");
    });
  },
};
</script>

<style lang="scss" scoped>
.td {
  @apply text-ontick-carbon-900 px-4 py-3 text-center text-xs dark:text-gray-300;
}
.slide-in {
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-300 ease-in-out;
  }
  &-enter, &-leave-to /* .fade-leave-active below version 2.1.8 */ {
    @apply -translate-y-full transform opacity-0;
  }
}
</style>
